<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'

export default
{
    mixins: [ adminTable ],

    methods:
    {
        fetch()
        {
            axios.get(process.env.API_URL + this.url).then(res => {
                this.data = res.data
                this.updateData()
            }).catch(e => {})
        },

        newGallery()
        {
            this.$router.push('/galleries/create')
        },

        editGallery(post)
        {
            this.$router.push(`/galleries/edit/${post.id}`)
        },
    },

    data()
    {
        return {
            data: [],
            url: '/v1/admin/galleries',
            tableName: 'tableGalleries',
            emptyModel: { title: null, images: [], slug: null, cover_id: null },
            columns: [ 'id', 'cover', 'title', 'year', 'day', 'updated_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    title: this.$t('POST.TITLE'),
                    cover: this.$t('GENERAL.COVER_IMAGE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                    year: this.$t('GENERAL.GALLERY_YEAR'),
                    day: this.$t('GENERAL.GALLERY_DAY'),
                },
                columnsDisplay: { 'updated_at': 'desktop', 'cover': 'desktop'  },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['title', 'created_at', 'updated_at'],
                sortable: ['id', 'updated_at', 'title'],
                responseAdapter: res => {
                    return res && res.data ? {
                      data: res.data.data,
                      count: res.data.count,
                    } : { data: [], count: 0}
                },
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.GALLERIES') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newGallery">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button v-if="props.row.is_published" class="btn btn-xs btn-warning" @click="unpublish(props.row)">
                            <icon name="eye-slash"></icon>
                        </button>
                        <button v-if="!props.row.is_published" class="btn btn-xs btn-primary" @click="publish(props.row)">
                            <icon name="eye"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="editGallery(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="cover" slot-scope="props">
                        <div class="text-center" v-if="props.row.cover && props.row.cover.id">
                            <img :src="props.row.cover.thumbnail_url" v-if="props.row.cover && props.row.cover.id">
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Galleries.vue